module.exports = __webpack_public_path__ + "static/media/logo_avacon.16dfd36c.svg";